import * as types from "./types";
import { combineReducers } from "redux";

function preinscripcionesPorColegio(state = [], { type, payload }) {
  return type === types.PREINSCRIPCIONES_POR_COLEGIO
    ? payload
    : type === types.RESET_PREINSCRIPCIONES_POR_COLEGIO
      ? []
      : state;
}

function preinscripcionesDelColegio(state = [], { type, payload }) {
  return type === types.ADDED_PREINSCRIPCIONES_DEL_COLEGIO
    ? [...state, payload]
    : type === types.CHANGED_PREINSCRIPCIONES_DEL_COLEGIO
      ? state.map(
          item =>
            item.idInscripcion === payload.idInscripcion ? payload : item
        )
      : type === types.REMOVED_PREINSCRIPCIONES_DEL_COLEGIO
        ? state.filter(item => item.idInscripcion !== payload.idInscripcion)
        : type === types.RESET_PREINSCRIPCIONES_DEL_COLEGIO
          ? []
          : state;
}

function datosColegio(state = {}, { type, payload }) {
  return type === types.OBTENER_DATOS_COLEGIO
    ? payload
    : type === types.LIMPIAR_DATOS_COLEGIO
      ? {}
      : state;
}

function datosPreinscripcion(state = {}, { type, payload }) {
  return type === types.OBTENER_DATOS_PREINSCRIPCION
    ? payload
    : type === types.LIMPIAR_DATOS_PREINSCRIPCION
      ? {}
      : state;
}

function dataSaved(state = { status: false, message: "" }, { type, payload }) {
  return type === types.DATA_SAVED
    ? payload
    : type === types.RESET_DATA_SAVED
      ? { status: false, message: "" }
      : state;
}

function columnaSeleccionada(
  state = { column: "nombre", direction: "ascending" },
  { type, payload }
) {
  return type === types.COLUMNA_SELECCIONADA
    ? payload
    : type === types.RESET_COLUMNA_SELECCIONADA
      ? "nombre"
      : state;
}

const reducer = combineReducers({
  preinscripcionesPorColegio,
  preinscripcionesDelColegio,
  datosColegio,
  datosPreinscripcion,
  dataSaved,
  columnaSeleccionada
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/preinscripciones/reducers.js